<template>
  <section>
    <search-bar />
    <service-nav />
    <banner-bg :text1="text1"></banner-bg>
    <table-nav />
    <simple-intro />
    <newest-case />
    <friendly-link />
  </section>
</template>
<script>
  import SearchBar from '@/components/SearchBar';
  import ServiceNav from '@/components/ServiceNav';
  import BannerBg from '@/components/BannerBg';
  import TableNav from '@/components/TableNav';
  import SimpleIntro from '@/components/SimpleIntro';
  import NewestCase from '@/components/NewestCase';
  import FriendlyLink from '@/components/FriendlyLink';
  export default{
    name: 'Home',
    data() {
      return {
          text1:"爱排名 全新技术、见效扣费<br>一站式营销服务"
      }
    },
    components: {
      SearchBar,
      ServiceNav,
      BannerBg,
      TableNav,     
      SimpleIntro,
      NewestCase,
      FriendlyLink
    }
  }
</script>
<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/views/home.vue